import React from 'react';
import PropTypes from 'prop-types';

const Connection = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="38"
    viewBox="0 0 35 38"
    {...props}>
    <g fill={colour} fillRule="evenodd">
      <path
        d="M32.013 12.076c-.213 0-.421-.03-.626-.073a15.393 15.393 0 01-2.969 17.636c-2.794 2.793-6.654-.625-10.918-.625-4.264 0-8.124 3.418-10.919.624a15.397 15.397 0 01-2.927-17.72 2.953 2.953 0 01-.92.158 2.91 2.91 0 01-1.29-.31A17.416 17.416 0 000 18.719c0 9.666 7.835 17.5 17.5 17.5S35 28.385 35 18.72c0-2.514-.54-4.9-1.495-7.061a2.908 2.908 0 01-1.492.418" // eslint-disable-line max-len
        transform="translate(0 .03)"></path>
      <path
        d="M28.376 12.835c-6.258-5.534-15.755-5.528-22.006 0a.859.859 0 00-.03 1.257l1.869 1.845a.886.886 0 001.197.044c4.558-3.94 11.387-3.931 15.933 0 .348.3.872.278 1.197-.044l1.87-1.845a.859.859 0 00-.03-1.257m-11.003 4.538a3.475 3.475 0 100 6.949 3.475 3.475 0 000-6.95M34.47 6.672C24.85-2.225 9.89-2.222.277 6.671a.863.863 0 00-.02 1.249l1.86 1.843a.881.881 0 001.215.02c7.923-7.256 20.158-7.258 28.083 0a.881.881 0 001.215-.02l1.858-1.843a.863.863 0 00-.02-1.249" // eslint-disable-line max-len
        transform="translate(0 .03)"></path>
    </g>
  </svg>
);

Connection.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Connection;
